// Removed Ant Design icon import
// Removed Col, Input, Spin, Text imports
import { API } from 'aws-amplify';
import { debounce } from "lodash";
// Added CBSpin import
import { CBSpin } from '../../core/components/CBSpin';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalState } from '../../../store';
import { colorNeutralDark } from '../../../utils/colors';
import { useLocalization } from '../../../localization';
import { CBButton, CBHeader, CBUrlField } from '../../core/components/cbd';
// Removed Input destructuring
const VanityUrl = () => {
    const { t } = useLocalization();


    const [license] = useGlobalState('license')
    const [canSubmit,setCanSubmit] = useState(false)
  
    const [loading,setLoading] = useState(false)
    const [alias,setAlias] = useState(license.vanityAlias)

    const [canChange,setCanChange] = useState(license.vanityAlias == "")
    const [error,setError] = useState(null)

    useEffect(()=>{
      setAlias(license.vanityAlias)
    },[license])
   async function submitVanity(){
     try{
      
   if(alias.length >=5 && validateUserName(alias)){
     var res = await API.post('scan','/alias?action=setAlias',{
     body:{
        alias
      }
    }
     )
  
     window.location.reload()
  } else{
    setError(t('scheduler.vanityUrl.error.invalid'))
    setCanSubmit(false)
    setLoading(false)
  }
    } catch(ex) {
      //console.log(ex)
      setError(t('scheduler.vanityUrl.error.unavailable'))
      setLoading(false)
      
    } 
  
  }

  async function checkName(name){
    if(name.length < 5){
      setError(t('scheduler.vanityUrl.error.tooShort'))
      setLoading(false)
      setCanSubmit(false)
      return
    }
    
    try{
      
    var res = await API.get('scan','/alias?action=checkAlias&alias=' + encodeURIComponent(name),{
   }
    )
      setError(null)
      setCanSubmit(true)
      //console.log(alias)
      //console.log(name)
   } catch(ex) {

    //console.log(name)
    // console.log(ex)
    //  alert("bad")
    setError(t('scheduler.vanityUrl.error.unavailable'))
    setCanSubmit(false)
   }
 
   setLoading(false)
 }

  const queryUserName =  useCallback(debounce((name) => checkName(name),2000),[])
   

  function validateUserName(name) {
    var usernameRegex = /^[a-zA-Z0-9-_]+$/;
    return  name.match(usernameRegex)
  }
  // disabled={license.vanityAlias != ""}
    return <>
    <CBHeader label={license.vanityAlias != "" ? t('scheduler.vanityUrl.header.existing') : t('scheduler.vanityUrl.header.choose')} subheader={true}></CBHeader>
    {/* Removed bordered/title props from div */}
    <div>
    <center>
        {/* Replaced Col with div */}
        <div>
        <CBUrlField maxLength={25} value={license.trial ? 'your_name' : alias} disabled={license.trial || !canChange} label="https://calendarbridge.com/book/" hint={t('scheduler.vanityUrl.inputHint')}
      onChange={e =>{
        setLoading(true)
        var name = e.toLowerCase()
        var valid = validateUserName(name)
        if(valid || name =="") {
          setCanSubmit(false)
          setError(null)
          setAlias(name)
          queryUserName(name)
        } else {
          setCanSubmit(false)
          setLoading(false)
        }
      }
      }
      error={error}></CBUrlField>

        {/* Commented out Input remains */}
        {/* <Input disabled={license.trial || !canChange} maxLength={25} style={{width:400}} onChange={e=>{
      setLoading(true)
      var name = e.target.value.toLowerCase()
      var valid = validateUserName(name)
      if(valid || name =="") {
        setCanSubmit(false)
        setError(null)
        setAlias(name)
        queryUserName(name)
      } else {
        setCanSubmit(false)
        setLoading(false)
      }
      }} value={license.trial ? 'your_name' : alias} addonBefore={window.location.origin + "/book/"} defaultValue={license.trial ? 'yourname' : license.vanityAlias}></Input> */}
  {/* debounce + other */}


{/* Replaced Text and Spin */}
<div className="flex flex-col items-center justify-center mt-1"> {/* Added flex container */}
  <span className="text-sm text-gray-500">{t('scheduler.vanityUrl.validationHint')}</span> {/* Replaced Text with span and Tailwind */}
  {loading && (
    <CBSpin
      spinning={true}
      size="small" // Smaller spinner
      className="ml-2" // Added margin
      
    />
  )}
</div>
</div>
  {/* Removed empty div */}
  <div className="flex flex-row justify-center gap-x-4" style={{marginTop:8}}>
  {license.vanityAlias != "" && canChange && <div >
    <CBButton type="secondary" onClick={e => {
    setCanChange(false)
    setLoading(false)
    setCanSubmit(false)
    setAlias(license.vanityAlias)
}}>{t('common.cancel_button')}</CBButton></div>}

  {!license.trial && canChange && <CBButton disabled={!canSubmit || loading} onClick={e=> {
  
  setLoading(true)
  submitVanity()
  }}>{t('common.submit_button')}</CBButton>}
  
  
  {license.vanityAlias != "" && !canChange && <CBButton type="primary" onClick={e => setCanChange(true)}>{t('common.change_button')}</CBButton>}
  </div>
  </center>
  {license.trial && <center><Link
                key={5}
                to={`/dashboard/settings`}
                >{t('scheduler.vanityUrl.upgradeLink')}</Link></center>}
  </div>
  
  </>;
  }

export default VanityUrl